import type { FeelingId } from './bridge';

/** Sky colours for a feeling at a given hour; the patient home paints its world with these. */
export interface SkyTone {
  top: string;
  bottom: string;
  dark: boolean;
  near: string;
  far: string;
  water: string;
}

export function skyFor(feeling: FeelingId | null | undefined, hour: number): SkyTone {
  const night = hour < 5 || hour >= 20;
  const dusk = hour >= 17 && hour < 20;
  const dawn = hour >= 5 && hour < 8;
  if (night) {
    const heavy = feeling === 'stormy' || feeling === 'rainy';
    return {
      top: heavy ? '#1c2230' : '#14213d', bottom: heavy ? '#3a3f4f' : '#3d4a74',
      dark: true, near: '#24423b', far: '#2f4a52', water: '#1f3550',
    };
  }
  switch (feeling) {
    case 'stormy':
      return { top: '#3f4756', bottom: '#8a8f9c', dark: true, near: '#3e5a4c', far: '#56685f', water: '#4a5d6e' };
    case 'rainy':
      return { top: '#6f8294', bottom: '#c3cad0', dark: true, near: '#4f7360', far: '#7b9187', water: '#6a8799' };
    case 'cloudy':
      return { top: '#a9b8c3', bottom: '#ece6da', dark: false, near: '#6f9278', far: '#a3b8a4', water: '#8fb0bd' };
    default: {
      if (dusk) return { top: '#f19a74', bottom: '#fde3c0', dark: false, near: '#6c8f63', far: '#c79a7c', water: '#e9a98c' };
      if (dawn) return { top: '#f6b9a4', bottom: '#fdf0dc', dark: false, near: '#76a074', far: '#c3b7a0', water: '#a9cbd2' };
      return feeling === 'sunny'
        ? { top: '#6ec3ec', bottom: '#fdecc8', dark: false, near: '#6aa56e', far: '#a9cfa0', water: '#7cc4d9' }
        : { top: '#8fcbe6', bottom: '#f6efe0', dark: false, near: '#6f9f74', far: '#a9c9a6', water: '#8cc3cf' };
    }
  }
}

